import { render, staticRenderFns } from "./GuidedModePage.vue?vue&type=template&id=924f8e78"
import script from "./GuidedModePage.vue?vue&type=script&lang=ts"
export * from "./GuidedModePage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports